<script>

import { transformVNodeClassToObject } from '@/mikan/_shared/lib/utilities/vnode';

export default {
  functional: true,
  props: {
    isPrimary: {
      type: Boolean,
      default: false,
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isThirdary: {
      type: Boolean,
      default: false,
    },
  },
  render(h, { props, children }) {
    const child = children[0];
    if (!child) {
      return undefined;
    }

    const injectingClasses = {
      button: true,
      'button--primary': props.isPrimary,
      'button--danger': props.isDanger,
      'button--disabled': props.isDisabled,
      'button--secondary': props.isSecondary,
      'button--thirdary': props.isThirdary,
    };

    const classes = !child.data
      ? injectingClasses
      : {
          ...transformVNodeClassToObject(child.data.class),
          ...injectingClasses,
        };

    const scopeId = h('span').fnScopeId;
    const childDataAttrs = (child.data && child.data.attrs) || {};
    const attrs = !scopeId
      ? childDataAttrs
      : {
          ...childDataAttrs,
          [scopeId]: true,
        };

    if (!child.data) {
      child.data = { class: classes, attrs };
    } else {
      child.data.class = classes;
      child.data.attrs = attrs;
    }
    return child;
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.button {
  display: inline-block;
  box-sizing: border-box;
  padding: 10px 25px;
  border: $color-navy-20 solid 1px;
  background-color: $color-white;
  border-radius: 4px;
  color: $color-orange;
  font-weight: bold;
  transition: background-color $transition-base, border-color $transition-base;
  @include for-sp {
    padding: 10px 15px;
  }

  &:hover {
    background-color: $color-orange-ultra-light;
    cursor: pointer;
  }

  &:active {
    border-color: $color-orange;
  }

  &--primary {
    background-color: $color-orange;
    color: $color-white;

    &:hover {
      background-color: $color-mandarin;
    }
  }

  &--danger {
    background-color: $color-strawberry;
    color: $color-white;

    &:hover {
      background-color: $color-papaya;
    }
  }

  &--disabled {
    border-color: $color-navy-20;
    background-color: $color-navy-20;
    color: $color-white;

    &:hover {
      background-color: $color-navy-20;
      cursor: default;
    }

    &:active {
      border: 1px solid $color-navy-20;
    }
  }

  &--secondary {
    border-color: $color-navy-20;
    color: $color-rainy-blue;

    &:hover {
      border-color: $color-rainy-blue;
      background-color: $color-white;
      cursor: pointer;
    }
  }

  &--thirdary {
    border-color: $color-navy-20;
    color: $color-navy-70;

    &:hover {
      border-color: $color-navy-40;
      background-color: $color-white;
      cursor: pointer;
    }
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
